"use strict";

exports.__esModule = true;
exports.GridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Device = require("../../Device");
var _common = require("../common");
var _TileContext = require("../common/TileContext");
var _DeviceCard = require("./DeviceCard");
var _HeaderBand = require("./HeaderBand");
var _gridUtils = require("./gridUtils");
var _dec, _class, _GridElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Space between cells so neighbouring panels read as separate cards.
var CELL_GUTTER = 4;

// Text-only widgets that layouts drape over other cells (a caption in a
// chart's axis area, say). They were visible over a transparent chart; over a
// white card they must paint on top.
var OVERLAY_TYPES = new Set(["SectionLabel"]);

/**
 * Displays an editable grid.
 */
var GridElement = exports.GridElement = (_dec = _Device.DeviceContext.withContext, _dec(_class = (_GridElement = /*#__PURE__*/function (_Component) {
  function GridElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(GridElement, _Component);
  var _proto = GridElement.prototype;
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      position = _this$props.position,
      children = _this$props.children,
      device = _this$props.device,
      testid = _this$props.testid,
      render = _this$props.render;
    var colorProps = (0, _common.getWidgetColorProps)(this.props);

    // Inside a DeviceGrid item the grid is the device card itself.
    if (this.context === true && device != null) {
      return /*#__PURE__*/_react["default"].createElement(_DeviceCard.DeviceCard, {
        testid: testid,
        width: width,
        height: height,
        elements: children || [],
        device: device,
        colorProps: colorProps,
        interactionProps: (0, _common.getWidgetInteractionProps)(this.props),
        render: render,
        renderChild: function renderChild(child, index) {
          return _this.renderChild(child, index);
        }
      });
    }
    if (device != null && colorProps.backgroundColorSource != null) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: device.uuid
      }, colorProps), function () {
        return (
          /*#__PURE__*/
          // The band itself stays on the canvas; each cell shows the state in
          // its own way (a solid hero tile for the state, tints elsewhere).
          _react["default"].createElement("div", _extends({
            "data-testid": testid,
            style: {
              position: position,
              width: width,
              height: height,
              color: "#1B2227"
            }
          }, (0, _common.getWidgetInteractionProps)(_this.props)), _this.renderChildren())
        );
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": testid
    }, (0, _common.getWidgetInteractionProps)(this.props), {
      style: {
        height: height,
        width: width,
        position: position
      }
    }), this.renderChildren());
  }

  // A run of value tiles across the top of a device's grid (the operator
  // panel header) becomes the designed header band; everything else keeps its
  // configured cell.
;
  _proto.renderChildren = function renderChildren() {
    var _this2 = this;
    var _this$props2 = this.props,
      children = _this$props2.children,
      device = _this$props2.device,
      render = _this$props2.render;
    var elements = children || [];
    var layout = device != null ? (0, _HeaderBand.splitHeaderBand)(elements, function (child) {
      return (0, _gridUtils.getGridCellDimensions)(_this2.props, child.props);
    }) : null;
    if (!layout) {
      return elements.map(function (child, index) {
        return _this2.renderChild(child, index);
      });
    }
    return [/*#__PURE__*/_react["default"].createElement(_HeaderBand.HeaderBand, {
      key: "header-band",
      device: device,
      band: layout.band,
      actions: layout.actions,
      actionsRect: layout.actionsRect,
      rest: layout.rest,
      rect: layout.rect,
      render: render
    })].concat(layout.rest.map(function (_ref) {
      var child = _ref.child,
        index = _ref.index;
      return _this2.renderChild(child, index);
    }));
  };
  _proto.renderChild = function renderChild(child, index, gridProps) {
    if (gridProps === void 0) {
      gridProps = this.props;
    }
    var render = this.props.render;
    var cell = (0, _gridUtils.getGridCellDimensions)(gridProps, child.props);
    // A cell never runs past the grid. A layout that spans more columns or
    // rows than the grid has would otherwise push its content (a device grid
    // and its rows, say) past the screen's edge into a side scroll; here it
    // is cut at the edge instead.
    var right = Number.isFinite(gridProps.width) ? Math.min(cell.x + cell.width, gridProps.width) : cell.x + cell.width;
    var bottom = Number.isFinite(gridProps.height) ? Math.min(cell.y + cell.height, gridProps.height) : cell.y + cell.height;
    var x = cell.x + CELL_GUTTER;
    var y = cell.y + CELL_GUTTER;
    var width = Math.max(0, right - cell.x - 2 * CELL_GUTTER);
    var height = Math.max(0, bottom - cell.y - 2 * CELL_GUTTER);
    var style = {
      position: "absolute",
      left: x,
      top: y,
      width: width,
      height: height,
      zIndex: OVERLAY_TYPES.has(child.type) ? 1 : undefined
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: String(index),
      style: style
    }, render(Object.assign({}, child, {
      props: Object.assign({}, child.props, {
        x: 0,
        y: 0,
        width: width,
        height: height
      })
    }), index));
  };
  return GridElement;
}(_react.Component), _GridElement.contextType = _TileContext.DeviceCardContext, _GridElement.defaultProps = {
  testid: "GridElement",
  padding: 0
}, _GridElement)) || _class);